export default __webpack_public_path__ + "static/media/ah-temp-kanuele.38b5160c.png";